const Sizes = {
    desktop: "1000px",
    text: "960px",
    padding: "20px",
    mobile: "700px"
}

export default Sizes;